export interface EmailRequest {
  email: string;
}

/** Subset of Mailgun v4 single-address validate response ([docs](https://documentation.mailgun.com/docs/validate/single-valid-ir)). */
export interface ValidationResponse {
  address: string;
  is_disposable_address: boolean;
  is_role_address: boolean;
  reason: string[];
  result: string;
  risk: string;
  did_you_mean?: string | null;
}

export interface Email {
  email: string;
  created: string;
  updated: string;
  validation_status: ValidationResponse | null;
}

/** Mailgun `result` ([result types](https://documentation.mailgun.com/docs/validate/single-valid-ir)). */
export const MAILGUN_VALIDATION_RESULT_OPTIONS = [
  { text: "deliverable", value: "deliverable" },
  { text: "undeliverable", value: "undeliverable" },
  { text: "do_not_send", value: "do_not_send" },
  { text: "catch_all", value: "catch_all" },
  { text: "unknown", value: "unknown" },
] as const;

/** Mailgun `risk` ([field explanation](https://documentation.mailgun.com/docs/validate/single-valid-ir)). */
export const MAILGUN_VALIDATION_RISK_OPTIONS = [
  { text: "low", value: "low" },
  { text: "medium", value: "medium" },
  { text: "high", value: "high" },
  { text: "unknown", value: "unknown" },
] as const;
